import React from 'react';

import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { defineMessages } from '@techstyle/react-intl';

import { getNormalizedUrl } from '../../utils/routing';
import { Component as DefaultHead } from '../DefaultHead';

const defaultSEO = defineMessages({
  title: {
    id: 'site_seo_title.brand_title',
    defaultMessage: 'SAVAGE X FENTY | Lingerie by Rihanna',
  },
  uktitle: {
    id: 'site_seo_title.brand_title_uk',
    defaultMessage: 'SAVAGE X FENTY | Lingerie by Rihanna UK',
  },
  description: {
    id: 'site_seo_description.brand_content',
    defaultMessage: 'Intimates for women. Bras, Underwear and Accessories.',
  },
});

export default function ProductGridHead({
  noIndex,
  title: routeTitle,
  description: routeDescription,
  keywords: routeKeywords,
}) {
  const router = useRouter();

  const getHeadContent = () => {
    const urlPathConverted = getNormalizedUrl(router);
    if (urlPathConverted) {
      const seoTitleID = `site_seo_title.${urlPathConverted}`;
      const seoTitleIDUK = `site_seo_title.${urlPathConverted}_uk`;
      const seoDescription = `site_seo_description.${urlPathConverted}`;
      return {
        title: routeTitle || {
          id: seoTitleID,
          defaultMessage: 'SAVAGE X FENTY | Lingerie by Rihanna',
        },
        uktitle: routeTitle || {
          id: seoTitleIDUK,
          defaultMessage: 'SAVAGE X FENTY | Lingerie by Rihanna UK',
        },
        description: routeDescription || {
          id: seoDescription,
          defaultMessage:
            'Intimates for women. Bras, Underwear and Accessories.',
        },
      };
    }
    return defaultSEO;
  };

  const tld = useSelector(state => state.domain.tld);
  const { title, uktitle, description } = getHeadContent();

  if (title || description || noIndex) {
    return (
      <DefaultHead
        title={tld === '.co.uk' ? uktitle : title}
        description={description}
        keywords={routeKeywords}
        noIndex={noIndex}
      />
    );
  }
  return null;
}
